import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import './style.css'
import { initApp } from './app.js'

const app = document.getElementById('app')
initApp(app)
